export type TaskKind = "daily" | "weekly";

export interface Task {
  id: string;
  no: number;
}

export interface DailyTask extends Task {
  dateLineHour: number;
}

export interface WeeklyTask extends Task {
  dateLineHour: number;
  weekLineDow: number;
}

export interface TaskCompleteInfo {
  id: string;
  no: number;
  completed: boolean;
  completeAt: string;
}

export interface DailyTaskCompleteInfo extends TaskCompleteInfo {
  dateLineHour: number;
}

export interface WeeklyTaskCompleteInfo extends TaskCompleteInfo {
  dateLineHour: number;
  weekLineDow: number;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isImplementsDailyTaskCompleteInfo = (arg: any): arg is DailyTaskCompleteInfo => {
  return arg !== null
    && typeof arg === "object"
    && typeof arg.id === "string"
    && typeof arg.completed === "boolean"
    && typeof arg.completeAt === "string"
    && typeof arg.dateLineHour === "number"
    && typeof arg.weekLineDow === "undefined";
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isImplementsWeeklyTaskCompleteInfo = (arg: any): arg is WeeklyTaskCompleteInfo => {
  return arg !== null
    && typeof arg === "object"
    && typeof arg.id === "string"
    && typeof arg.completed === "boolean"
    && typeof arg.completeAt === "string"
    && typeof arg.dateLineHour === "number"
    && typeof arg.weekLineDow === "number";
};
